import { createSelector } from 'reselect';

export interface StoresState {
  regions: any[];
  stores: any[];
  country: any;
  citiesLoading: boolean;
  storesLoading: boolean;
  openCity: any;
}

export const initialState: StoresState = {
  regions: [],
  stores: [],
  country: {},
  citiesLoading: false,
  storesLoading: false,
  openCity: null,
};

const getStores = ({ stores }: any): StoresState => stores;

export const storesSelectors = {
  getRegions: createSelector(
    getStores,
    ({ regions }) => regions,
  ),

  getStores: createSelector(
    getStores,
    ({ stores }) => stores,
  ),

  getCountry: createSelector(
    getStores,
    ({ country }) => country,
  ),

  getCitiesLoading: createSelector(
    getStores,
    ({ citiesLoading }) => citiesLoading,
  ),

  getStoresLoading: createSelector(
    getStores,
    ({ storesLoading }) => storesLoading,
  ),

  getOpenCity: createSelector(
    getStores,
    ({ openCity }) => openCity,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/selectors.ts